import type { CSSProperties, ReactNode } from 'react';

/**
 * Etiqueta de estado (`rv-chip.js`, componentes.md §7): solo texto sobre su color, 12/600, sin punto delante. La misma
 * palabra lleva el mismo color en todas las pantallas.
 */
export type EstadoChip = 'confirmed' | 'neutral' | 'draft' | 'pending' | 'problem' | 'live';

const COLORES: Record<EstadoChip, CSSProperties> = {
    confirmed: { background: 'var(--rv-ink)', color: '#fff' },
    neutral: { background: 'var(--rv-paper)', color: 'var(--rv-fg-2)' },
    draft: { background: 'var(--rv-paper)', color: 'var(--rv-fg-2)' },
    pending: { background: 'var(--rv-warning-soft)', color: 'var(--rv-warning-ink)' },
    problem: { background: 'var(--rv-red)', color: '#fff' },
    live: { background: '#fff', color: 'var(--rv-red)', border: '1px solid var(--rv-red)' },
};

export function Chip({ estado, children }: { estado: EstadoChip; children: ReactNode }) {
    return (
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                fontFamily: 'var(--rv-font-sans)',
                fontSize: 12,
                fontWeight: 600,
                lineHeight: 1.2,
                padding: '5px 11px',
                borderRadius: 999,
                whiteSpace: 'nowrap',
                border: 'none',
                flexShrink: 0,
                ...COLORES[estado],
            }}
        >
            {children}
        </span>
    );
}
